<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
      <div class="nav-item" :class="{active:type===0}" @click="toInfo('/home/newsAdmin/newsList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconliebiao"></i>
          </div>
        </div>
        新闻资讯
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="toInfo('/home/newsAdmin/newsEdit')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconbiaodan2"></i>
          </div>
        </div>
        新闻编辑
      </div>

      <div class="nav-item" :class="{active:type===2}" @click="toInfo('/home/newsAdmin/knowledgeList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconliebiao"></i>
          </div>
        </div>
        知识管理
      </div>
      <div class="nav-item" :class="{active:type===3}" @click="toInfo('/home/newsAdmin/knowledgeEdit')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconbiaodan2"></i>
          </div>
        </div>
        知识编辑
      </div>
    </div>
    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
export default {
  name: "zwrAdmin",
  data() {
    return {
      type: '',
      zwNum: 0
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.$store.state.topNav = 10
  },
  methods: {
    toInfo(path) {
      this.$router.push(path)
    },
    setType(type) {
      this.type = type
    },

  }
}
</script>

<style scoped lang="scss">

</style>